import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/content";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [kw, setKw] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = kw.trim();
    const target = document.getElementById("featured");
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
    window.dispatchEvent(new CustomEvent("wg-search", { detail: q }));
    setOpen(false);
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md shadow-soft border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 md:px-6" aria-label="主导航">
        <a href="#top" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-white">
            <i className="ri-bubble-chart-fill text-xl"></i>
          </span>
          <span className={`font-heading text-xl font-bold whitespace-nowrap ${scrolled ? "text-foreground-950" : "text-foreground-950"}`}>
            51黑瓜
          </span>
        </a>

        <ul className="hidden items-center gap-1 lg:flex">
          {navLinks.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition hover:bg-background-100 hover:text-foreground-950"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden items-center gap-3 lg:flex">
          <form onSubmit={goSearch} className="relative" role="search">
            <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
            <input
              value={kw}
              onChange={(e) => setKw(e.target.value)}
              placeholder="搜瓜料、搜明星"
              className="h-9 w-52 rounded-full border border-background-200 bg-background-100/60 pl-9 pr-3 text-sm outline-none transition focus:border-primary-300 focus:ring-2 focus:ring-primary-100"
            />
          </form>
          <a
            href="#faq"
            className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-white transition hover:bg-primary-600"
          >
            提个问题
          </a>
        </div>

        <button
          onClick={() => setOpen(!open)}
          aria-label="打开菜单"
          className="flex h-10 w-10 items-center justify-center rounded-full text-foreground-900 hover:bg-background-100 lg:hidden"
        >
          <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 lg:hidden">
          <ul className="space-y-1">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-lg px-3 py-2 text-sm font-medium text-foreground-700 hover:bg-background-100"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
          <form onSubmit={goSearch} className="relative mt-3">
            <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
            <input
              value={kw}
              onChange={(e) => setKw(e.target.value)}
              placeholder="搜瓜料、搜明星"
              className="h-10 w-full rounded-full border border-background-200 bg-background-100/60 pl-9 pr-3 text-sm outline-none focus:border-primary-300"
            />
          </form>
        </div>
      )}
    </header>
  );
}